export default __webpack_public_path__ + "static/media/photo-1513104890138-7c749659a591.6138051d.jpg";